import React from "react";
import FSection from "./fourthSections/FSection";
import { useNavigate } from "react-router-dom";

export default function Fourth() {
  const navigate = useNavigate();
  return (
    <section className="lg:py-20 py-12">
      <section className="sm:w-4/5 w-11/12 mx-auto">
        <h1 className="font-bold lg:text-6xl sm:text-5xl text-4xl text-themeBlue text-center">
          Our Services
        </h1>
        <p className="font-normal lg:text-3xl text-lg  text-black text-opacity-60 text-center mt-4">
          Our services are being offered through our dedicated specialised
          partners in China and Hong Kong.
        </p>
        <section className="grid lg:grid-cols-2 gap-x-10 gap-y-10 mt-10">
          <FSection
            img="1.png"
            title="Product Sourcing"
            desc="We offer sourcing and procurement services through our partners in China. Our services include, assessing 
              and selecting suppliers and products, managing suppliers to acquire the desired goods and services from them. 
              Contact us for a quotation or if you require more information."
          />
          <FSection
            img="2.png"
            title="Product Development"
            desc="Finally bring that new idea of yours to life. With our vast experience in product development in conjunction 
              with industry leading partners, we can offer you a full lifecycle service from concept to distribution. 
              Let us help you."
          />
          <FSection
            img="3.png"
            title="Quality Control"
            desc="Our services range from Pre-production, During Production and Final Inspection before Shipment. 
              We assist with accredited third-party quality inspectors to ensure products are up to specification."
          />
          <FSection
            img="4.png"
            title="Imports"
            desc="If you don't have an import license, don't stress. We can do the import on your behalf. Giving you more 
              time to focus on other responsibilities. We can take care of your imports from start to finish."
          />
        </section>
        <section className="grid sm:grid-cols-12 items-center mt-10">
          <p className="font-medium sm:text-2xl text-xl sm:col-span-9">
            These are just some of the services we offer. For more information,
            please chat to us
          </p>
          <div className="sm:col-span-3 sm:mt-0 mt-3">
            <button
              onClick={() => navigate("/support")}
              className="font-medium sm:text-xl text-base text-white bg-themeRed px-5 py-4 rounded 
              border border-themeRed hover:bg-transparent hover:text-themeRed float-right"
            >
              Say Hello
            </button>
          </div>
        </section>
      </section>
    </section>
  );
}
